import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/classNames';

interface SplashButtonProps {
  /** bootstrap-icons class, e.g. "bi-envelope-open". */
  icon: string;
  label: string;
  /** Route to navigate to on click. */
  to?: string;
  /** Custom click handler (overrides `to`). */
  onClick?: () => void;
  className?: string;
}

/**
 * Reproduces AST2's `.splash-button` tile: a 64px-tall AST-blue bar with a
 * bordered icon box on the left and a centered label.
 * (Source: index.php splash menu + css/style.css .splash-button*.)
 */
export function SplashButton({ icon, label, to, onClick, className }: SplashButtonProps) {
  const navigate = useNavigate();
  const handle = () => {
    if (onClick) onClick();
    else if (to) navigate(to);
  };
  return (
    <button type="button" className={cn('splash-button', className)} onClick={handle}>
      <span className="splash-button-graphic">
        <i className={cn('bi', icon, 'splash-icons')} />
      </span>
      <span className="splash-button-context">{label}</span>
    </button>
  );
}
